"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse["default"];
  }
});
var _Collapse = _interopRequireDefault(require("react-bootstrap/lib/Collapse"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Collapse.js
// module id = 1405
// module chunks = 25